import PropTypes from 'prop-types';
import { twJoin } from 'tailwind-merge';

import Text from 'shopper/components/Text';

const Placeholder = ({
  className,
  children,
  disabled = false,
  error = false,
}) => (
  <Text
    as="span"
    className={twJoin(
      'pointer-events-none',
      disabled
        ? 'text-neutral-low-300 dark:text-neutral-high-500'
        : error
          ? 'text-error-300 dark:text-error-300'
          : 'text-neutral-low-200 dark:text-neutral-high-400',
      className
    )}
  >
    {children}
  </Text>
);

Placeholder.propTypes = {
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  children: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
};

export default Placeholder;
